import * as React from "react";
const SvgFiRrTreeAlt = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#062147"
      d="M20.467 17.298a645 645 0 0 0-1.557-1.814c.32-.236.589-.544.78-.91a2.66 2.66 0 0 0-.165-2.754 426 426 0 0 0-1.885-2.09 2.47 2.47 0 0 0 1.083-1.073 2.42 2.42 0 0 0-.176-2.526C18.526 6.1 13.883.847 13.883.847c-.95-1.074-2.82-1.074-3.771 0 0 0-4.643 5.255-4.664 5.284a2.43 2.43 0 0 0-.176 2.526c.244.472.626.842 1.083 1.073 0 0-1.86 2.053-1.885 2.09a2.66 2.66 0 0 0-.166 2.753c.192.367.46.675.78.91 0 0-1.536 1.785-1.556 1.814a2.99 2.99 0 0 0-.185 3.098A2.99 2.99 0 0 0 5.999 22h4.997v1a1 1 0 1 0 2 0v-1h4.997a2.99 2.99 0 0 0 2.656-1.605 2.99 2.99 0 0 0-.185-3.097zm-1.585 2.167a.98.98 0 0 1-.885.535H13v-9a1 1 0 1 0-2 0v9H6.003a.98.98 0 0 1-.885-.535.98.98 0 0 1 .037-.994l2.429-2.818A1 1 0 0 0 6.827 14H6.67a.65.65 0 0 1-.59-.355.65.65 0 0 1 .013-.644l3.02-3.328A1.001 1.001 0 0 0 8.372 8h-.868a.49.49 0 0 1-.451-.264.42.42 0 0 1 .01-.418l4.552-5.148a.52.52 0 0 1 .387-.17c.088 0 .256.022.387.17l4.55 5.148a.42.42 0 0 1 .012.418A.49.49 0 0 1 16.5 8h-.868a.998.998 0 0 0-.741 1.672L17.91 13a.65.65 0 0 1 .013.644.65.65 0 0 1-.59.356h-.157a1 1 0 0 0-.757 1.652l2.429 2.818a.98.98 0 0 1 .037.994z"
    />
  </svg>
);
export default SvgFiRrTreeAlt;
